export default "__VITE_ASSET__C91QslOn__"